

























import { customAddr, customEdit } from "@/api/user";
import Vue, { PropType } from "vue";
import { Form, Loading } from "element-ui";
export default Vue.extend({
  data() {
    return {
      form: <customAddr>{
        title: "",
        address: "",
        desc: "",
        status: 1,
        uid: "0",
        lat: 0,
        lng: 0,
      },
      rules: {
        title: [{ required: true, message: "请输入标记点标题", trigger: "blur" }],
        address: [{ required: true, message: "请输入标记点位置", trigger: "blur" }],
        desc: [{ required: true, message: "请输入标记点说明", trigger: "blur" }],
      },
    };
  },
  props: {
    item: {
      type: Object as PropType<customAddr>,
    },
  },
  created() {
    if (this.item) {
      this.form = this.item as unknown as customAddr;
    }
  },
  methods: {
    onSubmit() {
        var that = this;
        (that.$refs.form as Form).validate((valid:any) => {
          if (valid) {
              let listLoading = Loading.service({});
            customEdit(that.form).then(res=>{
                that.$emit("close")
            }).finally(()=>{
                listLoading.close()
            })
          } else {
            return false;
          }
        });
    },
    onDel() {
        var that = this
        if(that.form.uid){
            that.form.status=-1
            let listLoading = Loading.service({});
            customEdit(that.form).then(res=>{
                that.$emit("close")
            }).finally(()=>{
                listLoading.close()
            })
        }
        
    },
    onCencel() {
      this.$emit("close");
    },
  },
});
